import { useEffect } from "react";
import { useAtomValue } from "jotai";
import { Badge } from "@common/index";
import { ComponentColor, ComponentSize } from "@common/types";
import { useOrderApi } from "@/hooks/apiHooks/useOrderApi";
import { orderStatusCountsAtom } from "@/store/orderAtoms";

export const ReceivedOrdersBadge = () => {
    const { getOrderStatuses } = useOrderApi();
    const counts = useAtomValue(orderStatusCountsAtom);

    useEffect(() => {
        getOrderStatuses().catch(() => {
            /* count is non-critical chrome; ignore failures */
        });
    }, [getOrderStatuses]);

    if (!counts.received) {
        return null;
    }

    return (
        <Badge
            color={ComponentColor.Warning}
            size={ComponentSize.SM}
            className="ml-1"
            title={`${counts.received} orders awaiting review`}
        >
            {counts.received}
        </Badge>
    );
};
